
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parts/literature",
      function () {
        return require("private-next-pages/parts/literature.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parts/literature"])
      });
    }
  